import React from 'react';
import styles from './GetStartedButton.module.css';

type GetStartedButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  aspect?: 'solid';
  isSent?: boolean;
};

export const GetStartedButton = React.forwardRef<
  HTMLButtonElement,
  GetStartedButtonProps
>(({ aspect, isSent, className, ...rest }, ref) => (
  <button
    ref={ref}
    {...rest}
    type="submit"
    tabIndex={0}
    className={[styles.root, isSent && styles.sent, className]
      .filter(Boolean)
      .join(' ')}
  />
));

GetStartedButton.displayName = 'GetStartedButton';
